var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "office-search-results-item",
      class: { active: _vm.selectedLocation === _vm.item.Guid },
      on: {
        click: function($event) {
          return _vm.handleSelectedBehavior(_vm.item.Guid)
        }
      }
    },
    [
      _c("div", { staticClass: "item-number" }, [_vm._v(_vm._s(_vm.index))]),
      _vm._v(" "),
      _c("a", { staticClass: "item-title", attrs: { href: _vm.item.Url } }, [
        _vm._v("Interim HealthCare of " + _vm._s(_vm.item.DisplayName))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "item-subtitle" }, [_vm._v(_vm._s(_vm.services))]),
      _vm._v(" "),
      _c("div", { staticClass: "item-content-container" }, [
        _c("div", { staticClass: "item-content-container-col" }, [
          _c("p", { staticClass: "item-distance" }, [
            _vm._v(_vm._s(_vm.item.Distance) + " Miles Away")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "item-address" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.item.Address.Address1) +
                ",\n                " +
                _vm._s(_vm.item.Address.Address2)
            ),
            _c("br"),
            _vm._v(
              "\n                " +
                _vm._s(_vm.item.Address.City) +
                ", " +
                _vm._s(_vm.item.Address.State.Abbreviation) +
                " " +
                _vm._s(_vm.item.Address.Zipcode) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          !_vm.item.OpensAllDay
            ? _c("p", { staticClass: "item-hours" }, [
                _c("b", [
                  _vm._v(_vm._s(_vm.isClosed ? "Closed Now" : "Open Now"))
                ]),
                _c("br", { staticClass: "d-none d-lg-block" }),
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.isClosed
                        ? _vm.nextDateTime
                        : "Closes " + _vm.item.Hours[_vm.currentDay].From
                    ) +
                    "\n            "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.OpensAllDay
            ? _c("p", { staticClass: "item-hours" }, [
                _c("b", [_vm._v("Open 24 hours")])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item-content-container-col" }, [
          _c(
            "a",
            {
              staticClass: "cta cta-primary cta-phone",
              attrs: { href: "tel:" + _vm.item.Phone }
            },
            [_vm._v(_vm._s(_vm.item.Phone))]
          ),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "cta cta-secondary", attrs: { href: _vm.item.Url } },
            [_vm._v("More Information")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }